const BOTTOM_THRESHOLD = 20

export function trackScroll(container, onReachedBottom) {
  let ticking = false

  container.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const { scrollTop, scrollHeight, clientHeight } = container
        if (scrollTop + clientHeight >= scrollHeight - BOTTOM_THRESHOLD) {
          onReachedBottom()
        }
        ticking = false
      })
      ticking = true
    }
  })
}

// Both branches fire in the same frame the measurement lands, so a caller can
// show scroll affordances without them flashing on a document that fits.
export function checkIfFitsWithoutScroll(container, onFits, onOverflows = () => {}) {
  const check = () => {
    const { scrollHeight, clientHeight } = container
    if (clientHeight === 0) {
      requestAnimationFrame(check)
      return
    }
    if (scrollHeight <= clientHeight + BOTTOM_THRESHOLD) {
      onFits()
    } else {
      onOverflows()
    }
  }
  requestAnimationFrame(check)
}

export function waitForVisible(element, callback) {
  if (element.clientWidth > 0) {
    callback()
    return
  }

  const observer = new MutationObserver(() => {
    if (element.clientWidth > 0) {
      observer.disconnect()
      callback()
    }
  })

  const stepParent = element.closest('[data-signing-flow-target]')
  if (stepParent) {
    observer.observe(stepParent, { attributes: true, attributeFilter: ['class'] })
  } else {
    callback()
  }
}
